import railyApiService from "../raily-api.service";
import rideSolvedRequestFactory from "./solved/ride-solved-request.factory";
import RideSolvedRequest, {
  RideSolvedRequestBody,
} from "./solved/ride-solved.request";
import RideSolvedResponse from "./solved/ride-solved.response";

const rideApiService = () => {
  const fetchSolvedRides = (
    request: RideSolvedRequest,
    abortSignal: AbortSignal
  ): Promise<RideSolvedResponse> => {
    const url = `/rides/solved`;

    const body: RideSolvedRequestBody =
      rideSolvedRequestFactory.create(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  return { fetchSolvedRides };
};

export default rideApiService;
